import { render, staticRenderFns } from "./ReviewTypePage.vue?vue&type=template&id=18a504e0&"
import script from "./ReviewTypePage.vue?vue&type=script&lang=js&"
export * from "./ReviewTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports